'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (fid, num) {
  return function (dispatch, getState) {
    var participant = getState().getIn(['persons', 'one', num]);

    if (participant) return;

    return dispatch(_defineProperty({
      fid: fid,
      num: num

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisParticipantUrl)(fid, num)
      },
      types: ['GET_FEIS_PARTICIPANT_START', 'GET_FEIS_PARTICIPANT', 'GET_FEIS_PARTICIPANT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/person/getFeisParticipant.js
// module id = 655
// module chunks = 0